import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination'
import 'swiper/css/navigation';

/* 아티스트 이미지 import */
import ISEOL from '../img/ISEOL.png'
import TAERIM from '../img/TAERIM.png'
import SSABI from '../img/SSABI.png'
import SOYEON from '../img/SOYEON.png'

/* SNS ICON import */
import AFREECA from '../img/afreeca.png'
import YOUTUBE from '../img/youtube.svg'
import INSTAGRAM from '../img/instagram.png'

function Artist() {
    return(
        <div>
            <div className='title-animate title'>
                ARTIST
            </div>
            <Swiper
                slidesPerView={2}
                pagination={{ clickable: true }}
                navigation
                loop
                centeredSlides
                autoplay={{
                  delay: 5000
                }}
                modules={[Autoplay, Navigation, Pagination]}
            >
            <SwiperSlide>
                <div className='artist-wrapper'>
                    <div className='artist-img'>
                        <img src={ SOYEON } alt='SOYEON' />
                        <span className='title'>소연</span>
                    </div>
                    <div className='sns-icon'>
                        <a className='sns-icon' key='instagram' href='https://www.instagram.com/lsoyeonb' target='_blank' rel='noopener noreferrer' >
                            <img src={ INSTAGRAM } alt='INSTAGRAM'/>
                        </a>
                        <a className='sns-icon' key='youtube' href='https://www.youtube.com/@ddoyeoning' target='_blank' rel='noopener noreferrer' >
                            <img src={ YOUTUBE } alt='YOUTUBE'/>
                        </a>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='artist-wrapper'>
                    <div className='artist-img'>
                        <img src={ TAERIM } alt='TAERIM' />
                        <span className='title'>숏태림</span>
                    </div>
                    <div className='sns-icon'>
                        <a key='youtube' href='https://www.youtube.com/@Shorts_Taerim' target='_blank' rel='noopener noreferrer' >
                        <img src={ YOUTUBE } alt='YOUTUBE'/>
                        </a>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='artist-wrapper'>
                    <div className='artist-img'>
                        <img src={ ISEOL } alt='' />
                        <span className='title'>이설</span>
                    </div>
                    <div className='sns-icon'>
                        <a key='instagram' href='https://www.instagram.com/leesnoww_' target='_blank' rel='noopener noreferrer' >
                            <img src={ INSTAGRAM } alt=''/>
                        </a>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='artist-wrapper'>
                    <div className='artist-img'>
                        <img src={ SSABI } alt='SSABI' />
                        <span className='title'>싸비</span>
                    </div>
                    <div className='sns-icon'>
                        <a key='youtube' href='https://www.youtube.com/@user-rs2dn7wy5o' target='_blank' rel='noopener noreferrer' >
                        <img src={ YOUTUBE } alt='YOUTUBE'/>
                        </a>
                        <a key='afreeca' href='https://bj.afreecatv.com/dooly22' target='_blank' rel='noopener noreferrer' >
                        <img src={ AFREECA } alt='AFREECA'/>
                        </a>
                    </div>
                </div>
            </SwiperSlide>
          </Swiper>
        </div>
    );
}

export default Artist;